import React, {Component} from 'react';
import {connect} from 'react-redux'
import {ModalBody, Input} from 'reactstrap';
import {fetchRegistration} from './../actions/postRegistration'
import {Loader} from './../../../components/loader'
import {constOnlyCountries, constPreferredCountries} from "../../../constants";
import {parsePhone} from "../../../functions/phone";
import {LoginLink} from "./login";
import IntlTelInput from 'react-intl-tel-input';

class Registration extends Component {
    constructor(props) {
        super(props);
        this.state = {
            phone: parsePhone(props.phone),
            first_name: '',
            email: '',
            dob: '',
            password: '',
        };
        this.confirmAction = this.confirmAction.bind(this);
        this.modalLine = this.modalLine.bind(this);
        this.changeInput = this.changeInput.bind(this);
        this.editPhone = this.editPhone.bind(this);
    }

    confirmAction() {
        let state = this.state;
        let props = this.props;
        const {dispatch} = props;
        let data = {
            phone: state.phone,
            first_name: state.first_name,
            email: state.email,
            dob: state.dob,
            password: state.password,
        };
        dispatch(fetchRegistration(data, props.onAfterRegistration));

    }

    modalLine(content) {
        return (
            <div className="modal-line mt-4">
                {content()}
            </div>
        );
    }

    changeInput(event) {
        let id = event.target.id;
        let state = {};
        state[id] = event.target.value;
        this.setState({...state});
    }

    editPhone(status, value, countryData, number) {
        this.setState({
            phone: parsePhone(value, countryData.iso2),
        })
    }

    render() {
        const props = this.props,
            state = this.state,
            isFetching = props.modal.isFetching;
        return (
            <div>
                <div className="modal-scroll">
                    {
                        isFetching ? <Loader/> : null
                    }
                    <ModalBody>
                        {
                            this.modalLine(() => (
                                <Input value={state.first_name} placeholder="Имя" id={'first_name'}
                                       onChange={this.changeInput}/>
                            ))
                        }
                        {
                            /*this.modalLine(() => (
                                <Input value={state.dob} placeholder="Дата рождения" id={'dob'}
                                       onChange={this.changeInput}/>
                            ))*/
                        }
                        {
                            this.modalLine(() => (
                                <IntlTelInput
                                    placeholder={"Телефон"}
                                    preferredCountries={props.setting.content.primary.countries ||constPreferredCountries()}
                                    onlyCountries={constOnlyCountries()}
                                    onPhoneNumberChange={this.editPhone}
                                    value={state.phone}
                                    css={['intl-tel-input w-100', 'form-control modal-input w-100']}
                                    telInputProps={{
                                        // style: {
                                        //     background: props.setting.rightModal.body.input.background,
                                        //     color: props.setting.rightModal.body.input.color,
                                        //     borderColor: props.setting.rightModal.body.input.borderColor,
                                        // }
                                    }}
                                />
                            ))
                        }
                        {
                            this.modalLine(() => (
                                <Input type="email" value={state.email} placeholder="Почта" id={'email'}
                                       onChange={this.changeInput}/>
                            ))
                        }
                        {
                            this.modalLine(() => (
                                <Input type="password" id={'password'} placeholder="Пароль" value={state.password}
                                       onChange={this.changeInput}/>
                            ))
                        }
                        <div className="submit-button-container position-relative mt-4">
                            <div className="button pointer-no-select"
                                 onClick={() => {props.openLogin(props.onAfterRegistration)}}>Войти
                            </div>
                            <div className="submit-button pointer-no-select" onClick={this.confirmAction}>
                                Регистрация
                            </div>
                        </div>
                    </ModalBody>
                </div>
            </div>
        )
    }
}

const MapStateToProps = function mapStateToProps(state) {
    return {
        modal: state.authState.registration,
        route: state.appState.route,
        setting: state.appState.setting,
    }
};

const mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        closeModal: () => {
            dispatch({type: 'closeMiniModal',});
        },
        openLogin: (onAfterLogin) => {
            dispatch({
                type: 'openMiniModal',
                header: 'Вход',
                children: <LoginLink onAfterLogin={onAfterLogin}/>,
                onClose: () => {
                    dispatch({type: 'closeMiniModal'})
                }
            });
        },
        dispatch
    };
};


export const RegistrationLink = connect(MapStateToProps, mapDispatchToProps)(Registration);